import PropTypes from 'prop-types';
import { maxSizeDesktop, spacingExtraLarge, spacingMedium } from 'helpers/style';
import { TextExtraLargeRapid } from '../../common/text';
import { Flex } from '../Flex';
import styled from '@emotion/styled';

const dimmed = (props) => (props.dimmed ? { opacity: 0.5 } : null);

export const StatisticBase = styled.div`
    padding: ${spacingExtraLarge};

    ${maxSizeDesktop} {
        padding: ${spacingMedium};
    }

    width: 100%;
    ${dimmed};
    display: inline-block;
    color: white;
`;

StatisticBase.propTypes = {
    dimmed: PropTypes.bool,
};

StatisticBase.defaultProps = {
    blacklist: ['dimmed'],
};

export const Content = styled(Flex)`
    white-space: nowrap;
`;

Content.defaultProps = {
    alignItems: 'baseline',
};

export const NoDataPadding = styled.div`
    padding-top: 5px;
`;

export const Number = styled(TextExtraLargeRapid)`
    margin-right: 3px;
`;

export const KPIStatisticBase = styled(StatisticBase)`
    padding: ${spacingExtraLarge} 24px;
    ${maxSizeDesktop} {
        padding: ${spacingMedium} 24px;
    }
`;
